import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// CRA inlines env at build time; never use a Node-only fallback that becomes localhost in the browser bundle.
export const API_BASE =
  typeof window !== 'undefined'
    ? (process.env.REACT_APP_BACKEND_URL || '')
    : (process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000');
